import { faFolder } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import type { Workspace } from '@workspace/domain/workspace';
import type { Folder } from '@workspace/view-model-folder/domain/Folder';
import { Link } from 'react-router-dom';
import { UserPagePathBuilder } from '@user/pages/UserPagePathBuilder';
import { HighlightText } from './HighlightText';
import { classNames } from '@framework/utils';

type Props = {
  workspace: Workspace;
  folder: Folder;
  searchKeyword?: string;
  isExternal?: boolean;
};

export const FolderItemTitle: React.FC<Props> = ({ workspace, folder, searchKeyword, isExternal = false }: Props) => {
  return (
    <Link
      to={UserPagePathBuilder.workspaceFolderPage(workspace.id, folder.id)}
      className={classNames('flex w-full items-center rounded-sm py-1 pr-1 focus:outline-none')}
      {...(isExternal && { target: '_blank', rel: 'noopener noreferrer' })}
    >
      <FontAwesomeIcon icon={faFolder} className="mr-1 text-brand" />
      <HighlightText className="truncate" text={folder.name} keyword={searchKeyword || ''} />
    </Link>
  );
};
